import { DataBean } from "../DataBean";

export class MassMailItem extends DataBean {

   
  
   
}
